// The contact form Layout block (app/Views/event/modules/contact_form.php): posts the form to the standalone contact
// path (/contact/{hash}) and shows the answer inline. Without this script the form posts normally and the server
// redirects back to the block.
const recaptchaToken = async (action) => {
    const script = document.querySelector('script[src*="recaptcha/enterprise.js"]');
    const key = script ? new URL(script.src).searchParams.get('render') : '';
    if (!key || !window.grecaptcha?.enterprise) {
        return '';
    }
    await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));

    return window.grecaptcha.enterprise.execute(key, { action });
};

export const initContactForms = (root) => {
    root.querySelectorAll('form[data-contact-form]').forEach((form) => {
        const status = form.querySelector('[data-contact-status]');
        const button = form.querySelector('button[type="submit"]');
        const show = (text, error) => {
            status.textContent = text;
            status.classList.toggle('is-error', error);
        };

        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            form.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
            if (!form.checkValidity()) {
                form.querySelectorAll(':invalid').forEach((el) => el.classList.add('is-invalid'));
                show(form.dataset.msgInvalid, true);

                return;
            }
            button.disabled = true;
            show(form.dataset.msgSending, false);
            try {
                form.elements.reCaptchaToken.value = await recaptchaToken('CONTACT');
                const response = await fetch(form.action, {
                    method: 'POST',
                    body: new FormData(form),
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    credentials: 'same-origin',
                });
                const data = await response.json();
                // the token of the next request
                document.getElementsByName(data.csrf_token_name).forEach((input) => { input.value = data.csrf_token_value; });
                if (data.message === 'ok') {
                    form.reset();
                    show(data.text, false);

                    return;
                }
                Object.keys(data.errors || {}).forEach((name) => form.elements[name]?.classList.add('is-invalid'));
                show(data.text, true);
            } catch {
                show(form.dataset.msgError, true);
            } finally {
                button.disabled = false;
            }
        });
    });
};
